import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const faqs = [{
  question: '¿Cómo recibo el producto?',
  answer: 'Es 100% digital. Recibirás acceso inmediato por correo electrónico después de tu compra. Podrás acceder desde nuestra plataforma segura.'
}, {
  question: '¿Para qué edad es recomendado?',
  answer: 'Está diseñado para niños de 4 a 8 años que están aprendiendo a leer o que necesitan reforzar su lectura y ganar fluidez.'
}, {
  question: '¿Qué pasa si no funciona?',
  answer: 'Tienes 30 días de garantía. Si aplicas el método y no ves resultados, te devolvemos el 100% de tu dinero sin preguntas incómodas.'
}, {
  question: '¿Necesito experiencia para usarlo?',
  answer: 'No. El sistema incluye videos paso a paso que te guían en todo momento. Está diseñado para padres ocupados, no necesitas ser maestra.'
}, {
  question: '¿Puedo usarlo en celular?',
  answer: 'Sí, funciona en cualquier dispositivo: celular, tablet o computadora. Puedes acceder en cualquier momento y lugar.'
}];
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="pt-10 pb-12 px-4 bg-white" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8" data-id="element-98">
          Preguntas frecuentes
        </h2>

        <div ref={ref} className={`space-y-4 ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-99">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-blue-200" data-id="element-100">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-101">
                <span className="font-bold text-gray-800 text-lg" data-id="element-102">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-103" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-104">
                <div className="p-5 pt-0 text-gray-600 leading-relaxed bg-gray-50/50" data-id="element-105">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}